export default "__VITE_ASSET__2e781cc5__"